import { AsyncPipe, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';

import { FullAddressStepComponent } from './full-address-step/full-address-step.component';
import { IndexAddressStepComponent } from './index-address-step/index-address-step.component';
import { HintAddressStepComponent } from './hint-address-step/hint-address-step.component';
import {
  AddressSelectorAbstract
} from '../../../../common/components/order-form/step-address/address-selector.abstract';
import { RestoSelectComponent } from '../../header/resto-picker/resto-select/resto-select.component';

@UntilDestroy()
@Component({
  selector: 'app-address-selector',
  templateUrl: './address-selector.component.html',
  styleUrls: ['./address-selector.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressSelectorComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AddressSelectorComponent),
      multi: true,
    }
  ],
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    ReactiveFormsModule,
    NgTemplateOutlet,
    FullAddressStepComponent,
    IndexAddressStepComponent,
    HintAddressStepComponent,
    RestoSelectComponent,
  ]
})
export class AddressSelectorComponent extends AddressSelectorAbstract {
  @Input() isFullView: boolean = true;
}
